import localStorage from './LocalStorageHepler'

export default class AbstractHttpService {
  public _localStorage: typeof localStorage

  constructor () {
    this._localStorage = localStorage
  }
}
